// The brand, as its screens show it: the channel view (Dashboard), AI presence,
// territories, deep-dive, BLAST, and the components they share (KPI band,
// score bar, study pulse).
export default {
  commun: {
    aujourdhui: 'today',
    dansJours: 'in {n} d',
    dansMois: 'in {n} mo',
    reco: {
      priorite: 'PRIORITY',
      considerer: 'TO CONSIDER',
      radar: 'RADAR',
    },
    hubIndice: '{mentions} mentions · {auteurs} distinct authors',
    moyenneCluster: 'Cluster average {n}',
    fermer: 'close',
    chargement: 'Loading…',
    chargementImpossible: 'Could not load',
    sauvegardeImpossible: 'Could not save',
    presenceIA: 'AI presence',
    indisponible: 'unavailable',
    partAudience: 'audience share',
    confiance: 'confidence',
    nonSegmente: 'Unsegmented',
    et: '{debut} and {fin}',
    lesAssistants: 'the assistants',
    citation: '‘{texte}’',
  },
  chaine: {
    sousTitre: 'Dashboard · brand score, 4R, persona',
    portefeuille: 'Portfolio',
    audienceAnalysee: 'audience analysed',
    polarisation: 'Polarisation: {label}',
    genererBrief: 'Generate a brief',
    depuisSnapshot: 'since the {date} snapshot',
    bssInfo: 'Brand score (BSS) = weighted average of the 4Rs against the reference cluster',
    ouvrirDeepDive: 'Open the deep-dive',
    moyenneCluster: 'cluster average {n}',
    pasDeScore: 'No score yet: run an analysis from Brand V3.',
    voirFicheComplete: 'See the full profile (vocabulary, consumption, world, behaviour)',
    voirFiche: 'See the full profile',
    autresPersonas: 'Other personas · {n}',
    personasNonCalculees: 'Personas not computed for this brand.',
    opportunite: 'Strategic opportunity',
    ouvrirBrief: 'Open the brief',
    territoires: 'Territories',
    secondaire: 'Secondary',
    secondaireTitre: 'Inherited from a sub-brand, not detected directly on this brand: % relative to the other secondary territories',
    territoiresVide: 'No territories detected: run an analysis (they are detected during the audit).',
    audienceDit: 'What your audience says',
    audienceDitVide: 'Not enough signals to extract recurring mentions.',
    elleSuit: 'What they follow',
    chaineSuivie: 'followed channel',
    affinite: 'affinity {n}%',
    infere: 'inferred',
    infereTitre: 'Inferred by the analysis: to be confirmed',
    affinitesVide: 'Affinities unavailable: compute the V2 personas.',
    prochainsEvenements: 'Upcoming events',
    extraitCalendrier: 'Taken from the calendar generated on {date}',
    aucunEvenement: 'No upcoming events in the calendar.',
    pasDeCalendrier: 'No calendar yet: generate it after an audit.',
    voirCalendrier: 'see the project calendar →',
    mesureeLe: 'measured on {date}',
    nouvelleMesure: 'new measurement in progress',
    ensemble: 'overall',
    muetTitre: '{nom} answered none of the questions (key or credits): this is not ‘does not cite’',
    citeTitre: '{nom} cites the brand in {pct}% of the questions where it is not named',
    premiereMesure: 'First measurement in progress: the scores arrive when it ends.',
    pasMesuree: 'Not measured yet: what the assistants say about the brand is measured at the next deep audit.',
    voirReponses: 'see each answer →',
    pleinePage: 'full page ↗',
    pleinePageTitre: 'Open as a full page',
  },
  presence: {
    dansAssistants: '{marque} in AI assistants',
    sous: 'What {assistants} answer when asked the questions a user would ask, without the brand being named. Cited? At what rank? Against whom?',
    mesureEnCours: 'measurement in progress: the scores arrive when it ends',
    mesureeLe: 'Measured on {date}.',
    seRemesure: 'Measured again at every deep audit of the brand.',
    lecture: 'Loading…',
    aucune: 'No measurement yet. AI presence is measured during the brand’s deep audit: nine questions put to six assistants, for around one dollar. It will appear here, and in the audit report, at the end of the next deep audit.',
    citeeSpontanement: 'cited unprompted',
    positionMoyenne: 'average position',
    partDeVoix: 'share of voice',
    connaissance: 'knowledge',
    indispo: 'unavailable: {n} unanswered questions | unavailable: {n} unanswered question | unavailable: {n} unanswered questions',
    indispoNote: '(key or credits; this is not ‘does not cite’)',
    enCours: 'in progress',
    ensemble: 'Overall',
    formule: '60% presence · 25% position · 15% knowledge: a set formula, written to be changed.',
    cout: "Cost: {'$'}{montant}.",
    question: 'Question',
    spontanee: 'unprompted',
    assistee: 'prompted',
    citee: 'cited',
    absente: 'absent',
    connaissances: {
      fidele: 'accurate',
      approximative: 'approximate',
      confondue: 'confused',
      inconnue: 'unknown',
    },
    tons: {
      positif: 'positive',
      neutre: 'neutral',
      negatif: 'negative',
      mixte: 'mixed',
    },
  },
  kpi: {
    jumeaux: '{n} twins | {n} twin | {n} twins',
    age: 'Age',
    genre: 'Gender',
    homme: 'M',
    femme: 'F',
    nonBinaire: 'NB',
    plateformes: 'Platforms',
    webAutre: 'Web / other',
    creneaux: 'Time slots',
    creneau: {
      Matin: 'Morning',
      Midi: 'Afternoon',
      Soir: 'Evening',
      Nuit: 'Night',
    },
    tauxClic: 'Click rate',
    filClic: 'of the feed triggers a click',
    pasDeFil: 'no feed on this outing',
    ressenti: 'Reaction',
    aime: 'liked {n}',
    mitige: 'mixed {n}',
    decroche: 'dropped off {n}',
    aucunClic: 'no clicks on the feed',
  },
  pulse: {
    legende: 'twins questioned · in parallel, each blind to the others',
    enCours: 'Questioning in progress',
    consolide: 'Consolidated',
  },
  territoires: {
    titre: 'My Territories',
    sousTitre: '{marque}’s territories, enriched by your twins',
    chargement: 'Loading territories…',
    pctMarque: '% of the brand',
    isosEnrichi: 'twins enriched the territory · 30 d',
    isosEnrichiTitre: 'Outings by your brand’s twins that brought back signal on this territory (last 30 days)',
    sessions: 'sessions · 7 d',
    sessionsTitre: 'Field sessions run over the last 7 days',
    persistants: 'persistent signals',
    persistantsTitre: 'Creators and topics that persist in YOUR twins’ observations (a signal must recur to count)',
    ecarts: 'perceived vs expected gaps',
    ecartsTitre: 'Perceived vs expected gaps detected in the Arena: material for decisions',
    dernierTerrain: 'last fieldwork {date}',
    aucunTerrain: 'no fieldwork yet',
    envoyer: 'Send twins',
    vide: 'No territory detected: run an analysis (they are detected during the audit).',
  },
  deepDive: {
    sousTitre: '{marque} · uniform anatomy: metric → chart → why → how → what to do → sourcing',
    moyenneCluster: 'cluster average',
    calcul: 'Computing the deep-dive (metrics + insights)…',
    pourquoi: 'Why it matters',
    comment: 'How it is calculated',
    methode: 'Score normalised 0-100 against the reference cluster (rolling 90-day window, recalculated at each analysis). No generative modelling in the score: only measured signals (engagement metrics, occurrences, batch-computed sentiment).',
    metriquesEntree: 'Input metrics: {liste}.',
    quoiFaire: 'What it means: what to do',
    analyseEnCours: 'Analysis in progress…',
    insightsIndispo: 'Insights unavailable: rerun the deep-dive after an analysis.',
    sourcingTexte: 'Every point can be rebuilt from the stored signals (source_url + raw_payload on each row). Raw YouTube data is purged after 30 days (ToS III.E.4): only the aggregated scores remain.',
    signauxRetenus: '{n} signals kept on {plateforme}',
    scoreCalcule: 'score computed on {date}',
    dateCalcul: 'Date of the last Brand Strength computation',
  },
  blast: {
    sousTitre: 'Build · Launch · Analyze · Scale or Terminate - 1 variable per short',
    deplacementNonSauve: 'Move not saved',
    verdictNonEnregistre: 'Verdict not recorded',
    aucune: 'No BLAST campaign',
    aucuneTexte: 'A campaign starts from a brief: open a brand’s brief and click ‘Send to BLAST’. Orion generates a test plan: each short isolates one variable, with a falsifiable hypothesis and a target KPI.',
    allerPortefeuille: 'Go to the portfolio',
    campagne: 'Campaign ‘{territoire}’: {objectif}.',
    objectifDefaut: '1 variable isolated per short',
    glissez: 'Drag the cards between columns.',
    statuts: {
      draft: 'draft',
      running: 'running',
      scaled: 'scaled',
      terminated: 'terminated',
    },
    enregistrementVerdict: 'Recording the verdict…',
    scaleTitre: 'The territory is validated: we invest in full production',
    terminateTitre: 'The territory is disproved: we stop',
    iterateTitre: 'Ambiguous results: a new round of tests',
    dernierVerdict: 'Last verdict: {decision} on {date}',
    preTitre: 'Estimated pre-score (persona panel): descriptive, to be confirmed by measurement',
    pre: 'pre',
    reel: 'actual',
    kpiAtteint: 'KPI met',
    kpiManque: 'KPI missed',
    scoreReel: 'Actual score',
    kpiAtteintQuestion: 'KPI met?',
    oui: 'yes',
    non: 'no',
    enregistrer: 'Save',
    consignerTitre: 'Record the result of this test',
    annuler: 'cancel',
    modifier: 'edit',
    saisir: 'enter the result',
  },
}
